export const EmptyState = ({ icon: Icon, title, message, action }) => (
  <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
    <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-accent">
      {Icon && <Icon size={38} className="text-primary" weight="duotone" aria-hidden />}
    </div>
    <h3 className="font-heading text-xl font-semibold text-stone-900">{title}</h3>
    <p className="mt-2 max-w-sm text-sm text-stone-500">{message}</p>
    {action && <div className="mt-6">{action}</div>}
  </div>
);
